
import { defineComponent, PropType } from 'vue';
import { ICteDocumentoReferenciado } from '@/models/Entidades/Compras/ConhecimentoTransporte/ICteDocumentoReferenciado';

export default defineComponent({
  name: 'ConhecimentoTransporteDocumentos',
  props: {
    documentos: {
      type: Array as PropType<ICteDocumentoReferenciado[]>,
    },
  },
  setup() {
    const colunas = [
      {
        title: 'Chave de Acesso',
        dataIndex: 'chaveAcesso',
        key: 'chaveAcesso',
      },
      {
        title: 'Cód. Nota Fiscal Entrada',
        dataIndex: 'codigoNotaFiscalEntrada',
        key: 'codigoNotaFiscalEntrada',
      },
    ];

    return {
      colunas,
    };
  },
});
